import type {
  InsulationFunnelSettingsInterface,
  InsulationFunnelStep,
  InsulationProductWithCalculations,
} from '@innogy/feh/models';
import { createAction } from '@ngrx/store';
import { createNamedFunnelActions } from '@innogy/feh/shared';

const feature = 'Insulation';
const PREFIX = `[${feature} Funnel]`;

export const {
  initializeInsulationFunnelStepAction,
  setInsulationFunnelInitializedAction,
  clearInsulationFunnelInitializedAction,
  onInsulationFunnelNavigationAction,
  handleInsulationFunnelPrivateErrorAction,
  handleInsulationFunnelGenericErrorAction,
  toggleInsulationProductSelectionAction,
  confirmInsulationProductSelectionAction,
  resetInsulationProductSelectionAction,
  selectInsulationProductsAction,
  mintInsulationTrackingIdAction,
} = createNamedFunnelActions<
  typeof feature,
  InsulationFunnelStep,
  InsulationFunnelSettingsInterface,
  InsulationProductWithCalculations
>(feature);

export const handleInsulationFunnelAddressNotFoundErrorAction = createAction(
  `${PREFIX} Address not found Error`
);
